import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AvatarProfile } from "@performyard/py-components";

import { MultipleSelectEmployee } from "../../../components/Inputs/SelectEmployee";

import { TextEditor } from "../../TextEditor";
import css from "../AddFormModal.module.scss";

const SelectAuthor = (props) => {
	const { handleSetAddForm, authors = [], formComment = "", form } = props;
	const [localAuthors, setLocalAuthors] = useState(authors);

	const enableSelection = (!form.whoCanAddForm.any_employee && form.subject !== "self") || null;

	useEffect(() => {
		handleSetAddForm(localAuthors, "authors");
	}, [localAuthors]);

	useEffect(() => {
		handleSetAddForm(formComment.length, "characterCount");
	}, [formComment]);

	const changeFormComment = (comment) => {
		handleSetAddForm(comment, "formComment");
	};

	const labelProps = {
		size: "paragraph-3",
		weight: "regular",
	};

	return (
		<div className={css.modalContent}>
			<div className={css.addFormModalDescription}>
				<div>{enableSelection ? "Which authors should complete this form?" : "Assigned authors:"}</div>
			</div>

			{enableSelection ? (
				<div data-testid="authorPicker" className={css.editPersonContainer}>
					<MultipleSelectEmployee value={localAuthors} onChange={setLocalAuthors} />
				</div>
			) : (
				localAuthors.map((employee) => (
					<div key={employee.id} data-testid="undraggableAuthorItem">
						<AvatarProfile employeeId={employee.id} employeeName={employee.name} avatarSize={20} noLink />
					</div>
				))
			)}

			{form.allowComments ? (
				<div className={css.addMessageContainer}>
					<div className={css.messageLabel}>
						<h3>Message</h3>
						<TextEditor
							id={"360-message-request"}
							className={css.textareaInput}
							labelProps={labelProps}
							maxLength={500}
							minHeight={184}
							maxHeight={184}
							showCharacterCounter={true}
							value={formComment}
							onChange={(val) => changeFormComment(val)}
						/>
						<h4>
							<FontAwesomeIcon icon={faCircleInfo} />
							<span>
								{" "}
								Message will be permanently displayed to any approvers, authors, signers and subjects
								(if form is visible to the subject).
							</span>
						</h4>
					</div>
				</div>
			) : null}
		</div>
	);
};

SelectAuthor.propTypes = {
	handleSetAddForm: PropTypes.func.isRequired,
	form: PropTypes.object.isRequired,
	authors: PropTypes.array,
	formComment: PropTypes.string,
	characterCount: PropTypes.number,
};

export default SelectAuthor;
